import { t } from 'i18next';

export const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export const normalizeEmail = (email) => email.trim().replaceAll(' ', '');

const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EMAIL_VALIDATION = {
  email: (value) => !value || EMAIL_FORMAT.test(normalizeEmail(value)) || t('Please enter a valid email address'),
};

export const normalizeEmailsFromArray = (emails) => emails.map((email) => normalizeEmail(email));

export const normalizeEmailFromData = (data) => {
  const { email } = data;

  if (!email) return data;

  return {
    ...data,
    email: normalizeEmail(email),
  };
};
